import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
//i18n
import { useNavigate } from "react-router-dom"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import { useParams } from "react-router-dom"
import ProjectContext from "context/projects/projectContext"
import ModalDeleteProject from "components/Dashboard/modals/project/modalDeleteProject"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import i18n from "i18n"
import ModalEditProject from "./ModalEditProject"
import { useContactsLight } from "../../Contacts/hooks/useContacts"
import ModalCargandoDuplicado from "./ModalCargandoDuplicado"
import { IconButton, Menu, MenuItem } from "@mui/material"

const DropdownSettings = props => {
  const projectContext = useContext(ProjectContext)
  const { deleteProject } = projectContext
  const {
    addToFavorites,
    removeFromFavorites,
    getProject,
    projectInfo,
    duplicateProject,
  } = useContext(ProjectContext)
  // Obtener contactos light desde el hook
  const organizationId =
    props.project?.organizationId || projectInfo?.organizationId || ""
  const { data: contactosLight = [], isLoading: isContactsLoading } =
    useContactsLight(organizationId, !!organizationId)

  const [menu, setMenu] = useState(false)
  const [cardMenuAnchor, setCardMenuAnchor] = useState(null)
  const navigate = useNavigate()
  const { projectId } = useParams()
  const [open, setOpen] = useState(false)

  const removeP = () => {
    if (projectId) {
      deleteProject(projectId)
      setTimeout(() => {
        navigate("/")
      }, 500)
    } else {
      deleteProject(props.project.projectId)
      setTimeout(() => {
        navigate("/")
      }, 500)
    }
  }

  const gestionEq = () => {
    if (projectId) {
      navigate("/equipos/" + projectId)
    } else {
      navigate("/equipos/" + props.project.projectId)
    }
  }

  useEffect(() => {
    if (projectId) {
      getProject(projectId)
    }
  }, [projectId])

  const marcar = () => {
    if (projectInfo.favourite == undefined) {
      addToFavorites(projectId)
    } else if (projectInfo.favourite == false) {
      addToFavorites(projectId)
    } else {
      removeFromFavorites(projectId)
    }
  }

  const [openLoading, setOpenLoading] = useState(false)
  const [loadingDupli, setLoadingDupli] = useState(false)
  const [checkTemplate, setCheckTemplate] = useState(false)

  const duplicateProjectFunc = async is_template => {
    if (is_template) {
      setCheckTemplate(true)
    } else {
      setCheckTemplate(false)
    }
    setLoadingDupli(true)
    setOpenLoading(true)
    if (projectId) {
      await duplicateProject(projectId, is_template)
    } else {
      await duplicateProject(props.project.projectId, is_template)
    }
    setLoadingDupli(false)
  }

  const marcar2 = () => {
    if (props.project.favourite == undefined) {
      addToFavorites(props.project.projectId)
    } else if (props.project.favourite == false) {
      addToFavorites(props.project.projectId)
    } else {
      removeFromFavorites(props.project.projectId)
    }
    setTimeout(() => {
      location.reload()
    }, 500)
  }

  const [openEliminate, setOpenEliminate] = useState(false)

  const closeCardMenu = () => setCardMenuAnchor(null)

  return (
    <>
      <React.Fragment>
        {props.imCard == true ? (
          <>
            <IconButton
              id="settingb"
              size="small"
              aria-label="more"
              aria-controls={
                cardMenuAnchor ? "project-card-actions-menu" : undefined
              }
              aria-haspopup="true"
              aria-expanded={cardMenuAnchor ? "true" : undefined}
              onClick={e => setCardMenuAnchor(e.currentTarget)}
              sx={{
                display: "inline-flex",
                color: "#414141",
                padding: 0,
                overflow: "visible",
                ...(props.imList
                  ? { marginTop: 0 }
                  : { marginTop: "-16px", marginLeft: "310px" }),
              }}
            >
              <MoreVertIcon
                sx={{
                  fontSize: 20,
                  color: "#414141",
                  paddingTop: "2px",
                  ...(props.imList
                    ? {
                        marginTop: 0,
                        ...(props.centerInCell ? {} : { marginLeft: "20px" }),
                      }
                    : { marginTop: "-5px" }),
                }}
              />
            </IconButton>
            <Menu
              id="project-card-actions-menu"
              anchorEl={cardMenuAnchor}
              open={Boolean(cardMenuAnchor)}
              onClose={closeCardMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                data-element="deleteProjectBtn"
                onClick={() => {
                  closeCardMenu()
                  setOpenEliminate(true)
                }}
              >
                {i18n.t("Eliminar")}
              </MenuItem>
              <MenuItem
                data-element="editProjectBtn"
                onClick={() => {
                  closeCardMenu()
                  setOpen(true)
                }}
              >
                {i18n.t("Editar Proyecto")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  closeCardMenu()
                  duplicateProjectFunc(false)
                }}
              >
                {i18n.t("Duplicar Proyecto")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  closeCardMenu()
                  duplicateProjectFunc(true)
                }}
              >
                {i18n.t("Duplicar como plantilla")}
              </MenuItem>
              {props.project ? (
                <MenuItem
                  onClick={() => {
                    closeCardMenu()
                    marcar2()
                  }}
                >
                  {props.project.favourite
                    ? props.project.favourite == true
                      ? "Quitar de favoritos"
                      : "Marcar como favoritos"
                    : "Marcar como favoritos"}
                </MenuItem>
              ) : null}
            </Menu>
          </>
        ) : (
          <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="d-inline-block"
          >
            <DropdownToggle
              id="settingb"
              style={{
                marginTop: "-10px",
                color: "#414141",
                margin: "0px",
                padding: "0px",
              }}
            >
              <SettingsOutlinedIcon
                className="settingsProject"
                style={{ color: "#414141", width: "20px", paddingTop: "2px" }}
              />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                tag="b"
                onClick={() => setOpenEliminate(true)}
                data-element="deleteProjectBtn"
                style={{ lineHeight: "20px", cursor: "pointer" }}
              >
                {" "}
                {i18n.t("Eliminar")}
              </DropdownItem>
              {/* <DropdownItem tag="b" onClick={() => {navigate("/equipos/"+projectId)}} style={{lineHeight: '20px', cursor:'pointer'}}>
            {" "}
           {i18n.t("Gestionar Equipo")}
          </DropdownItem> */}
              <DropdownItem
                tag="b"
                onClick={() => {
                  setOpen(true)
                }}
                data-element="editProjectBtn"
                style={{ lineHeight: "20px", cursor: "pointer" }}
              >
                {" "}
                {i18n.t("Editar Proyecto")}
              </DropdownItem>
              {projectInfo ? (
                <DropdownItem
                  tag="b"
                  onClick={() => {
                    marcar()
                  }}
                  style={{ lineHeight: "20px", cursor: "pointer" }}
                >
                  {" "}
                  {projectInfo.favourite
                    ? projectInfo.favourite == true
                      ? i18n.t("Quitar de favoritos")
                      : i18n.t("Marcar como favoritos")
                    : i18n.t("Marcar como favoritos")}
                </DropdownItem>
              ) : null}
            </DropdownMenu>
          </Dropdown>
        )}
      </React.Fragment>
      <ModalDeleteProject
        openEliminate={openEliminate}
        setOpenEliminate={setOpenEliminate}
        project={props.project}
      />
      {open && (
        <ModalEditProject
          open={open}
          onClose={() => setOpen(false)}
          onSave={() => {}}
          projectInfo={props.imCard ? props.project || {} : projectInfo || {}}
          contactos={contactosLight}
          isContactsLoading={isContactsLoading}
        />
      )}
      {openLoading && (
        <ModalCargandoDuplicado
          checkTemplate={checkTemplate}
          open={openLoading}
          setOpen={setOpenLoading}
          loading={loadingDupli}
        />
      )}
    </>
  )
}

DropdownSettings.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  imCard: PropTypes.bool,
  project: PropTypes.object,
  imList: PropTypes.bool,
  centerInCell: PropTypes.bool,
}

export default DropdownSettings
